// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table_tableContainer__eo0uP","table":"Table_table__RH3zT"};